import { __rest, __assign } from 'tslib';
import React__default from 'react';
import { DataViewKey } from '@keepeek/commons';
import KFSearch from '../KFSearch/index.js';

var KFFolderSearch = function KFFolderSearch(_a) {
    var rest = __rest(_a, []);
    return React__default.createElement(KFSearch, __assign({ dataViewKey: DataViewKey.SEARCH, isFolderSearch: true }, rest));
};

export { KFFolderSearch as default };
//# sourceMappingURL=index.js.map
